"use strict";
var r, e;
function i() {
  return e || (e = 1, r = Math.min), r;
}
export {
  i as __require
};
//# sourceMappingURL=index.es313.js.map
